<article class="box mouse-pointer" role="button" (click)="onClick($event)" (keydown.enter)="onClick($event)" (keydown.space)="onClick($event)" [ngStyle]="{'--c': htmlColor()}">
    <div class="inner">
        <div class="icon">
            <i [class]="icon"></i>
        </div>
        <div class="meta">
            @if (count != null) {
            <div class="count">{{count}}</div>
            }
            <div class="label">{{text}}</div>
        </div>
    </div>
</article>